import DevelopmentInWasteTypesTenant from "@/components/Graphs/DevelopmentInWasteTypes/tenant";
import TenantRecyclingRateOverTime from "@/components/Graphs/RecyclingRateOverTime/tenant";
import RecyclingRateRanking from "@/components/Graphs/RecyclingRateRanking";

import { Customer } from "server/dwhApi/customers/types.js";
import { twMerge } from "tailwind-merge";

import { CollapsableTableDataInterface } from "../../customerDetails.interface";
import DetailsTable from "../DetailsTable";

type Props = {
  tenantTableData: CollapsableTableDataInterface;
  tenantsCurrent: Customer[];
};

const ExpandedViewGrid: React.FC<Props> = ({
  tenantTableData,
  tenantsCurrent,
}: Props) => {
  return (
    <div
      className={twMerge(
        "bg-hover-color w-full gap-4 p-5 text-start",
        "flex flex-row overflow-scroll",
      )}
    >
      <DetailsTable tenantTableData={tenantTableData} />
      <TenantRecyclingRateOverTime
        tenantId={tenantTableData.id}
        tenantCategoryId={tenantTableData.categoryId}
      />
      <RecyclingRateRanking
        tenantsData={tenantsCurrent}
        tenantId={tenantTableData.id}
        tenantCategoryId={tenantTableData.categoryId}
      />
      <DevelopmentInWasteTypesTenant tenantId={tenantTableData.id} />
    </div>
  );
};

export default ExpandedViewGrid;
